var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer fixed-bottom" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "footer__text d-flex align-items-center sm-footer" },
          [_vm._v("© Ocean Network Express Pte. Ltd. All rights reserved. ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }